export const addFlexibleSalesChannels = (variant) => {
  const { source, seller } = variant;

  const sourceId = source?.id ?? null;
  const sellerId = seller?.id ?? null;

  return {
    sourceId,
    sellerId,
  };
};
